import { render, staticRenderFns } from "./leave_team.vue?vue&type=template&id=400158dc"
import script from "./leave_team.vue?vue&type=script&lang=ts"
export * from "./leave_team.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports